export { default } from './ImageWithSubtitleContainer.js';
